// const Firestore = require('@google-cloud/firestore');
//
// const firestore = new Firestore();

const savedSearchesCollectionName = 'savedSearches'

const userDataPath = uid => 'userData/' + uid

export default class SavedSearchSource {
    firestore = null

    constructor(fs) {
        this.firestore = fs
    }

    userdata = uid => this.firestore.doc(userDataPath(uid))
    collection = (uid) => this.userdata(uid).collection('savedSearches')
    search = (uid, name) => this.collection(uid).doc(name)

    processSnapshot = snapshot => {
        console.log('Processing', snapshot)
        const result = []
        // if (snapshot && snapshot.data()) {
        //     for (let [key, value] of snapshot.data()) {
        //         console.log('Processing', key, ':', value)
        //         result.push({
        //             name: key,
        //             filters: value
        //         })
        //     }
        // }
        snapshot.forEach(doc => {
            // doc.data() is never undefined for query doc snapshots
            console.log(doc.id, " => ", doc.data());
            result.push({
                name: doc.id,
                filters: doc.data()
            })
        })
        return result;
    }

    savedSearchesFor = uid => {
        return new Promise((resolve, reject) => {
            this.collection(uid).get()
                .then(querySnapshot => {
                    resolve(this.processSnapshot(querySnapshot))
                })
                .catch(err => {
                    console.log('Error:', err)
                    resolve([])
                })
        })
    }

    watchSavedSearchesFor = (uid, cb) => {
        console.log('Start watching searches for:', uid)
        return this.collection(uid)
                .onSnapshot({
                    next: snapshot => {
                        console.log('Received searches...')
                        cb(this.processSnapshot(snapshot))
                    },
                    error: (err) => console.log('error:', err)
                })
    }

    stopWatchingSavedSearchesFor = uid => this.collection(uid).onSnapshot(() => {})

    setSearch = (uid, name, filters) => (
        new Promise((resolve, reject) => {
            this.search(uid, name)
                .set(filters)
                .then(s => resolve(s))
                .catch(err => {
                    console.log('Error creating search:', err, uid, name)
                    resolve(null)
                })
        })
    )


    createSavedSearchFor = (uid, name, filters) => {
        console.log('Creating search:', name, 'for', uid)
        return this.setSearch(uid, name, filters)
    }

    updateSavedSearchFor = (uid, search) => this.setSearch(uid, search.name, search.filters)

    deleteSavedSearchFor = (uid, name) => (
        new Promise((resolve, reject) => {
            this.search(uid, name)
                .delete()
                .then(() => {
                    console.log('Deleted saved search', name, 'for', uid)
                    resolve(true)
                })
                .catch(err => {
                    console.log('Error deleting', name, 'for', uid)
                    resolve(false)
                })
        })
    )
}
